export const BROWSER_MODE_KEY = 'BrowserMode';
export const VOICE_TYPE_KEY = 'VoiceType';

export const BROWSER_MODES = {
  NEW: 'new',
  OLD: 'old',
};

export const VOICE_TYPES = {
  MALE: 'male',
  FEMALE: 'female',
};

export function getBrowserMode() {
  const value = (localStorage.getItem(BROWSER_MODE_KEY) || '').trim().toLowerCase();
  return value === BROWSER_MODES.OLD ? BROWSER_MODES.OLD : BROWSER_MODES.NEW;
}

export function isOldBrowserMode() {
  return getBrowserMode() === BROWSER_MODES.OLD;
}

export function getVoiceType() {
  const value = (localStorage.getItem(VOICE_TYPE_KEY) || '').trim().toLowerCase();
  return value === VOICE_TYPES.FEMALE ? VOICE_TYPES.FEMALE : VOICE_TYPES.MALE;
}

export function setLoginPreferences(browserMode, voiceType) {
  localStorage.setItem(BROWSER_MODE_KEY, browserMode);
  localStorage.setItem(VOICE_TYPE_KEY, voiceType);
}

export function setVoiceType(voiceType) {
  localStorage.setItem(VOICE_TYPE_KEY, voiceType);
}

export function clearLoginPreferences() {
  localStorage.removeItem(BROWSER_MODE_KEY);
  localStorage.removeItem(VOICE_TYPE_KEY);
}

export function getDigitAudioFolder() {
  return getVoiceType() === VOICE_TYPES.FEMALE ? 'female-voice' : 'number_recordings';
}

export function getCallbackVoiceFile() {
  return getVoiceType() === VOICE_TYPES.FEMALE
    ? 'call_back_voice_female.mp3'
    : 'call_back_voice.mp3';
}
